export enum ContractDocumentType {
	report,
	invoice,
}
